import type { Row } from 'react-table';

import type { TestRun } from '@bugbug/core/types/tests';
import { TestRunsActions } from '~/components/TestRunsActions/TestRunsActions';
import useRefreshTestRunsHistory from '~/views/RunsHistory/hooks/useRefreshTestRunsHistory';

export const TestRunsListRowActions = ({ row }: { row: Row<TestRun> }) => {
  const onDelete = useRefreshTestRunsHistory();

  return <TestRunsActions row={row} onDelete={onDelete} />;
};
